import classNames from "classnames";
import { capitalize } from "../../Helpers";
import { nb } from "date-fns/locale";
import React, { FC } from "react";
import { IntervalDay } from "../../Steps/FormSecondStep";
import {format} from "date-fns";

interface DayPickerItemProps {
  date: IntervalDay;
  selectedDay: Date;
  onClick: (date: Date) => void;
}

enum DayPickerElement {
  active = "day-picker__element--active",
  disabled = "day-picker__element--disabled",
}

export const DayPickerItem: FC<DayPickerItemProps> = ({
  date,
  selectedDay,
  onClick,
}) => {
  const active = date.date.getTime() === selectedDay?.getTime();
  const disabled = date.hasAppointments === false;

  function handleDateElementClick(date: Date, disabled = false) {
    if (!disabled) {
      onClick(date);
    }
  }

  return (
    <button
      onClick={() => handleDateElementClick(date.date, disabled)}
      className={classNames("d-flex flex-column day-picker__element", {
        [DayPickerElement.active]: active,
        [DayPickerElement.disabled]: disabled,
      })}
      type="button"
    >
      <span className="d-block text-center w-100 fs-5">
        {capitalize(format(date.date, "eeee", { locale: nb }))}
      </span>
      <span className="d-block text-center w-100 fw-bold">
        {format(date.date, "d", { locale: nb })}
      </span>
      <span className="d-block text-center w-100 fs-6 day-picker__month">
        {format(date.date, "MMMM", { locale: nb })}
      </span>
    </button>
  );
};
